import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//

import { mapActions, mapGetters, mapState } from "vuex";
import Amplitude from "@Shared/@Utils/amplitude";
import SessionIntervalsMixin from "@Shared/@Utils/shared-mixins/session/session-intervals-mixin";
import { LOAD_PERSONAL_DETAILS } from "../store/account/account-actions";
import { LOAD_PLAN_LIMITS } from "@Broker/@Modules/account-plan/store/account-plan-actions";
import { CURRENT_ACCOUNT_DETAILS, CURRENT_BROKERAGE_DETAILS, CURRENT_USER_DETAILS } from "../store/account/account-getters";
import PendoUtils from "@Shared/@Utils/pendo";
import store from "../../../store";
import { defineComponent } from "@vue/composition-api";
import { LOAD_EXTERNAL_SERVICES_STATUS } from "@Broker/@Modules/status-page/store/status-page-actions";
import { EXTERNAL_SERVICE_NAME } from "@Shared/@Types/status-page/types";
import { GLOBAL_MAINTENANCE_IN_PROGRESS } from "@Broker/@Modules/status-page/store/status-page-getters";
import { MAINTENANCE_MODE_INTERVAL_MS } from "@Shared/js/constants";
export default defineComponent({
  name: "AuthApp",
  mixins: [SessionIntervalsMixin],
  data() {
    return {
      socketResponse: "",
      checkIfMaintenanceInterval: null
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState("AccountStore", ["token"])), mapGetters("AccountStore", [CURRENT_USER_DETAILS, CURRENT_ACCOUNT_DETAILS, CURRENT_BROKERAGE_DETAILS])), mapGetters("StatusPageStore", [GLOBAL_MAINTENANCE_IN_PROGRESS])), {}, {
    maxKeepAlive() {
      return process.env.DEVELOPMENT ? 2 : 5;
    },
    pagesWithCache() {
      const includedPages = ["DripCampaignContainer", "DripCampaignDetailsContainer", "ApplicationsListContainer", "ClientBoardContainer", "ClientProfileContainer", "InactiveContainer"];
      return includedPages.join(",");
    },
    routerViewKey() {
      const includedRoutes = ["drip-campaign", "drip-campaign-edit", "applications", "boards", "client-profile", "inactive-clients"];
      const {
        name,
        fullPath
      } = this.$route;
      const hasRouterViewKey = _includesInstanceProperty(includedRoutes).call(includedRoutes, name);
      return hasRouterViewKey ? fullPath : undefined;
    }
  }),
  watch: {
    token: {
      immediate: true,
      handler(val) {
        if (!val) {
          var _context;
          if (_includesInstanceProperty(_context = window.location.hash).call(_context, "#/unverified")) return;
          window.location = "#/login";
        }
      }
    },
    [GLOBAL_MAINTENANCE_IN_PROGRESS](globalMaintenanceInProgress) {
      if (globalMaintenanceInProgress) {
        this.stopCheckingForMaintenance();
        this.$router.replace({
          name: "maintenance-message"
        });
      }
    }
  },
  async beforeMount() {
    Amplitude.updateVisits();
    this.startCheckingForMaintenance();
  },
  beforeDestroy() {
    this.$socket.disconnect();
    this.stopCheckingForMaintenance();
  },
  mounted() {
    if (this.token) {
      this.LOAD_PERSONAL_DETAILS().then(() => {
        //This call keeps the limits updated after loading the account details
        this.LOAD_PLAN_LIMITS();
        this.initPendo();
      });
      this.$auth.session.initFreshChat();
      this.$socket.connect(this.token, store);
    }
  },
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapActions("AccountStore", [LOAD_PERSONAL_DETAILS])), mapActions("AccountPlanStore", [LOAD_PLAN_LIMITS])), mapActions("StatusPageStore", [LOAD_EXTERNAL_SERVICES_STATUS])), {}, {
    initPendo() {
      PendoUtils.startSession(this.$auth.session.get());
    },
    async checkForMaintenance() {
      await this.LOAD_EXTERNAL_SERVICES_STATUS(EXTERNAL_SERVICE_NAME.GLOBAL);
    },
    startCheckingForMaintenance() {
      this.stopCheckingForMaintenance();
      this.checkIfMaintenanceInterval = setInterval(() => {
        this.checkForMaintenance();
      }, MAINTENANCE_MODE_INTERVAL_MS); //every 5 min
    },
    stopCheckingForMaintenance() {
      if (this.checkIfMaintenanceInterval) {
        clearInterval(this.checkIfMaintenanceInterval);
      }
    }
  })
});